
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";

export default defineComponent({
  name: "PricesTable",

  computed: {
    ...mapState(["prices"]),
  },
  methods: {
    ...mapActions(["getPricesFromApi"]),
  },
  mounted() {
    this.getPricesFromApi();
  },
});
